import { render, staticRenderFns } from "./34_ap_regimenes_soluciona.vue?vue&type=template&id=792fbad6&scoped=true&"
import script from "./34_ap_regimenes_soluciona.vue?vue&type=script&lang=js&"
export * from "./34_ap_regimenes_soluciona.vue?vue&type=script&lang=js&"
import style0 from "./34_ap_regimenes_soluciona.vue?vue&type=style&index=0&id=792fbad6&scoped=true&lang=css&"
import style1 from "./34_ap_regimenes_soluciona.vue?vue&type=style&index=1&id=792fbad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792fbad6",
  null
  
)

export default component.exports